export default "__VITE_ASSET__EegNKio0__"